import apiClient from 'ps-components/lib/apiClient';

export const DELETE_NOT_ACTIVE_SURVEYS_FAIL = 'DELETE_NOT_ACTIVE_SURVEYS_FAIL';
export const DELETE_NOT_ACTIVE_SURVEYS_SUCCESS = 'DELETE_NOT_ACTIVE_SURVEYS_SUCCESS';
export const GET_AUDIT_TRAIL_ERROR = 'GET_AUDIT_TRAIL_ERROR';
export const GET_AUDIT_TRAIL_START = 'GET_AUDIT_TRAIL_START';
export const GET_AUDIT_TRAIL_SUCCESS = 'GET_AUDIT_TRAIL_SUCCESS';
export const GET_NOT_ACTIVE_SURVEYS = 'GET_NOT_ACTIVE_SURVEYS';
export const GET_NOT_ACTIVE_SURVEYS_FAIL = 'GET_NOT_ACTIVE_SURVEYS_FAIL';
export const GET_NOT_ACTIVE_SURVEYS_SUCCESS = 'GET_NOT_ACTIVE_SURVEYS_SUCCESS';
export const INIT_DELETE_NOT_ACTIVE_SURVEYS = 'INIT_DELETE_NOT_ACTIVE_SURVEYS';
export const RESET_DELETE_STATUS = 'RESET_DELETE_STATUS';
export const SET_OFFSET = 'SET_OFFSET';
export const SET_SELECTED_SURVEYS = 'SET_SELECTED_SURVEYS';
export const GET_PENDING_SURVEYS_START = 'GET_PENDING_SURVEYS_START';
export const GET_PENDING_SURVEYS_SUCCESS = 'GET_PENDING_SURVEYS_SUCCESS';
export const GET_PENDING_SURVEYS_ERROR = 'GET_PENDING_SURVEYS_ERROR';
export const ADD_SURVEYS_START = 'ADD_SURVEYS_START';
export const ADD_SURVEYS_SUCCESS = 'ADD_SURVEYS_SUCCESS';
export const ADD_SURVEYS_ERROR = 'ADD_SURVEYS_ERROR';
export const DELETE_SURVEY_REQUEST_START = 'DELETE_SURVEY_REQUEST_START';
export const DELETE_SURVEY_REQUEST_SUCCESS = 'DELETE_SURVEY_REQUEST_SUCCESS';
export const DELETE_SURVEY_REQUEST_ERROR = 'DELETE_SURVEY_REQUEST_ERROR';
export const GET_PUBLISHERS_START = 'GET_PUBLISHERS_START';
export const GET_PUBLISHERS_SUCCESS = 'GET_PUBLISHERS_SUCCESS';
export const GET_PUBLISHERS_ERROR = 'GET_PUBLISHERS_ERROR';
export const SET_SELECTED_PUBLISHER = 'SET_SELECTED_PUBLISHER';
export const SET_NEW_SURVEY_NAME = 'SET_NEW_SURVEY_NAME';
export const SUBSCRIBE_SURVEYS_START = 'SUBSCRIBE_SURVEYS_START';
export const SUBSCRIBE_SURVEYS_SUCCESS = 'SUBSCRIBE_SURVEYS_SUCCESS';
export const SUBSCRIBE_SURVEYS_ERROR = 'SUBSCRIBE_SURVEYS_ERROR';
export const UPDATE_SURVEY_START = 'UPDATE_SURVEY_START';
export const UPDATE_SURVEY_SUCCESS = 'UPDATE_SURVEY_SUCCESS';
export const UPDATE_SURVEY_ERROR = 'UPDATE_SURVEY_ERROR';
export const UPDATE_PENDING_SURVEY = 'UPDATE_PENDING_SURVEY';
export const RESET_ADD_SURVEYS_ERROR = 'RESET_ADD_SURVEYS_ERROR';
export const RESET_DELETE_SURVEY_ERROR = 'RESET_DELETE_SURVEY_ERROR';
export const SLC_AUDIT_TRAIL_LIMIT = 25;

export const DATA_SET_TYPE = {
  CUSTOM: 'custom',
  STANDARD: 'standard'
};

export function getAuditTrail(limit, offset) {
  return async dispatch => {
    dispatch({ type: GET_AUDIT_TRAIL_START });
    try {
      const result = await apiClient.apiGet('/api/slu/survey-library-change/auditTrail', {
        params: {
          limit: limit || SLC_AUDIT_TRAIL_LIMIT,
          offset: offset || 0
        }
      });
      dispatch({
        type: GET_AUDIT_TRAIL_SUCCESS,
        auditTrails: result.data.auditTrails,
        totalCount: result.data.totalCount
      });
    } catch (error) {
      dispatch({ type: GET_AUDIT_TRAIL_ERROR });
      console.log(error);
    }
  };
}

export function getPendingSurveyRequests() {
  return async dispatch => {
    dispatch({ type: GET_PENDING_SURVEYS_START });
    try {
      const result = await apiClient.apiGet('/api/slu/survey-library-change/pendingSurveyRequests');
      dispatch({
        type: GET_PENDING_SURVEYS_SUCCESS,
        surveys: result.data.surveys
      });
    } catch (error) {
      dispatch({ type: GET_PENDING_SURVEYS_ERROR });
      console.log(error);
    }
  };
}

export function deleteSurveyRequest(requestToDelete) {
  return async dispatch => {
    dispatch({ type: DELETE_SURVEY_REQUEST_START });
    try {
      const result = await apiClient.apiDelete('/api/slu/survey-library-change/deleteSurveyRequest', {
        data: {
          surveyPk: requestToDelete.requestId
        }
      });
      if (!result.data.success) {
        throw Error(result.data.reason);
      }
      await dispatch(getPendingSurveyRequests());
      dispatch({ type: DELETE_SURVEY_REQUEST_SUCCESS });
    } catch (error) {
      dispatch({ type: DELETE_SURVEY_REQUEST_ERROR });
      console.log(error);
    }
  };
}

export function addSurveys(surveys) {
  return async dispatch => {
    try {
      dispatch({ type: ADD_SURVEYS_START });
      await apiClient.apiPost('/api/slu/survey-library-change/addSurveys', {
        surveys
      });
      await dispatch(getPendingSurveyRequests());
      dispatch({ type: ADD_SURVEYS_SUCCESS });
    } catch (error) {
      dispatch({ type: ADD_SURVEYS_ERROR });
      console.log(error);
    }
  };
}

export function setOffset(offset) {
  return { type: SET_OFFSET, offset };
}

export function getNotActiveSurveys() {
  return async dispatch => {
    dispatch({ type: GET_NOT_ACTIVE_SURVEYS });
    try {
      const result = await apiClient.apiGet('/api/slu/survey-library-change/getNotActiveSurveys');

      dispatch({
        type: GET_NOT_ACTIVE_SURVEYS_SUCCESS,
        result
      });
    } catch (error) {
      dispatch({ type: GET_NOT_ACTIVE_SURVEYS_FAIL, error });
      console.log(error);
    }
  };
}

export function getPublishers() {
  return async dispatch => {
    try {
      dispatch({ type: GET_PUBLISHERS_START });
      const result = await apiClient.apiGet('/api/slu/survey-library-change/publishers');
      dispatch({ type: GET_PUBLISHERS_SUCCESS, publishers: result.data.publishers });
    } catch (error) {
      dispatch({ type: GET_PUBLISHERS_ERROR });
      console.log(error);
    }
  };
}

export function setSelectedSurveys(surveys) {
  return { type: SET_SELECTED_SURVEYS, surveys };
}

export function deleteNotActiveSurveys(surveys) {
  return async dispatch => {
    dispatch({ type: INIT_DELETE_NOT_ACTIVE_SURVEYS });

    try {
      const result = await apiClient.apiDelete('/api/slu/survey-library-change/deleteNotActiveSurveysFromSite', {
        data: { surveys }
      });

      dispatch({ type: DELETE_NOT_ACTIVE_SURVEYS_SUCCESS });

      return result;
    } catch (error) {
      dispatch({ type: DELETE_NOT_ACTIVE_SURVEYS_FAIL, error });
      console.log(error);
    }
  };
}

export function setSelectedPublisher(publisher) {
  return { type: SET_SELECTED_PUBLISHER, publisher };
}

export function setNewSurveyName(surveyName) {
  return { type: SET_NEW_SURVEY_NAME, surveyName };
}

export function subscribeSurveys(userSignature, emailEnabled) {
  return async dispatch => {
    try {
      dispatch({ type: SUBSCRIBE_SURVEYS_START });
      await apiClient.apiPost('/api/slu/survey-library-change/subscribeSurveys', {
        userSignature,
        emailEnabled
      });
      const promises = [];
      dispatch(setOffset(0));
      promises.push(dispatch(getPendingSurveyRequests()));
      promises.push(dispatch(getAuditTrail(SLC_AUDIT_TRAIL_LIMIT, 0)));
      await Promise.all(promises);
      dispatch({ type: SUBSCRIBE_SURVEYS_SUCCESS });
    } catch (error) {
      dispatch({ type: SUBSCRIBE_SURVEYS_ERROR });
      console.log(error);
      throw error;
    }
  };
}

export function updateSurvey(surveyPk, notes, dataSetType, applyToSubgroups) {
  return async dispatch => {
    try {
      dispatch({ type: UPDATE_SURVEY_START });
      await apiClient.apiPost('/api/slu/survey-library-change/updateSurvey', {
        surveyPk,
        notes,
        dataSetType,
        applyToSubgroups
      });
      dispatch({ type: UPDATE_SURVEY_SUCCESS });
    } catch (error) {
      dispatch({ type: UPDATE_SURVEY_ERROR });
      console.log(error);
    }
  };
}

export function updatePendingSurvey(survey) {
  return { type: UPDATE_PENDING_SURVEY, survey };
}

export function resetAddSurveysError() {
  return { type: RESET_ADD_SURVEYS_ERROR };
}

export function resetDeleteSurveyError() {
  return { type: RESET_DELETE_SURVEY_ERROR };
}

export function resetDeleteStatus() {
  return { type: RESET_DELETE_STATUS };
}
